"use client";

import React from "react";
import { Facebook, Instagram, Linkedin, Twitter, ArrowUp } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  const services = ["Dental Implants", "Porcelain Veneers", "Smile Design", "Full Mouth Rehab", "Prosthodontics"];
  const quickLinks = [{
    label: "Home",
    href: "/HomePage"
  }, {
    label: "About Us",
    href: "#"
  }, {
    label: "Our Team",
    href: "#"
  }, {
    label: "Contact",
    href: "#"
  }];
  const legalLinks = [{
    label: "Privacy Policy",
    href: "#"
  }, {
    label: "Terms of Service",
    href: "#"
  }, {
    label: "Cookie Policy",
    href: "#"
  }, {
    label: "Accessibility",
    href: "#"
  }];
  const socialLinks = [{
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }];
  return <section data-section-id="4479" id="footer" className="bg-white border-t border-[#DDDDDD] pt-16 pb-8">
      <div className="container mx-auto px-6 md:px-12">
        {}
        <div className="flex justify-center mb-16">
          <img src="https://www.tmprosthodontics.com/wp-content/uploads/2019/03/HOME_01.jpg" alt="TM Prosthodontics Logo" className="h-12 w-auto object-contain" />
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-16">
          {}
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <h3 className="font-serif font-bold text-black text-lg mb-4 uppercase tracking-wider">
              Navigation
            </h3>
            <ul className="space-y-2">
              {quickLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-[12px] font-sans text-black hover:text-[#C19B4A] transition-colors uppercase tracking-widest">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <h3 className="font-serif font-bold text-black text-lg mb-4 uppercase tracking-wider">
              Specialties
            </h3>
            <ul className="space-y-2">
              {services.map((service, i) => <li key={i} data-index={i}>
                  <Link to="#" className="text-[12px] font-sans text-black hover:text-[#C19B4A] transition-colors uppercase tracking-widest">
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <h3 className="font-serif font-bold text-black text-lg mb-4 uppercase tracking-wider">
              Information
            </h3>
            <ul className="space-y-2">
              {legalLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-[12px] font-sans text-black hover:text-[#C19B4A] transition-colors uppercase tracking-widest">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <h3 className="font-serif font-bold text-black text-lg mb-4 uppercase tracking-wider">
              Connect
            </h3>
            <div className="flex gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} to={social.href} className="text-black hover:text-[#C19B4A] transition-colors" aria-label={social.label} data-index={i}>
                    <Icon className="size-5" />
                  </Link>;
            })}
            </div>
            <div className="mt-6 text-[12px] font-sans text-black uppercase tracking-widest">
              <p>paris, france</p>
              <p>Dr. ERIC leclercq</p>
            </div>
          </div>
        </div>

        <Separator className="bg-[#DDDDDD] mb-6" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[12px] font-sans text-black text-center md:text-left">© 2026 TM Prosthodontics – Dr. Eric Leclerq Prosthodontist. | Terms and Conditions | Privacy Policy</p>

          <Button variant="ghost" size="sm" onClick={scrollToTop} className="text-[12px] font-sans text-black hover:text-[#C19B4A] hover:bg-transparent p-0 h-auto font-normal gap-2 cursor-pointer uppercase tracking-widest">
            Back to Top
            <ArrowUp className="size-3" />
          </Button>
        </div>
      </div>
    </section>;
}